/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import ToggleButton from 'material/togglebutton/togglebutton';
// styles
import injectSheet from 'react-jss'
import styles from './placements_styles'
import Space from 'material/space/space';


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: ADS SECTION ~~~~~~~~~~ ========== */
const Placements = injectSheet(styles)((props) => {

  const {  
    beforeDesktopUnit,
    afterDesktopUnit,
    beforeMobileUnit,
    afterMobileUnit,
    version, 
    selectVersion, 
    visibility,
    onChange 
  } = props

  const placementVersion = [
    {label: 'Desktop', value: 'desktop'},
    {label: 'Mobile', value: 'mobile'}
  ]

  const showBeforeUnit = version === 'desktop' ? beforeDesktopUnit : beforeMobileUnit

  const showAfterUnit = version === 'desktop' ? afterDesktopUnit : afterMobileUnit

  return (
    <Space justifyContent={'space-between'} klass={`placements ${props.classes.placements}`} >
    <SectionGroupV2 
      title={'Placements'} 
      description={'Enable where each ad can display within the article sentiment unit'}
      indented
    >
      <Space gap={16} direction={'column'}>
      <ToggleButton selected={version} items={placementVersion} onChange={item => selectVersion(item.value)} />
      <Space gap={16} direction={'column'} klass={visibility === 'NONE' ? 'disabled' : ''}>
      <ConfigToggle 
        title={'Before article sentiment unit'}
        checked={showBeforeUnit}
        onChange={val => onChange(version === 'desktop' ? 'beforeDesktopUnit' : 'beforeMobileUnit', val)}
      />
      <ConfigToggle 
        title={'After article sentiment unit'}
        checked={showAfterUnit}
        onChange={val => onChange(version === 'desktop' ? 'afterDesktopUnit' : 'afterMobileUnit', val)}
        gap={16}
      />
      </Space>
      </Space>
    </SectionGroupV2>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Placements;